/**
 * @generated SignedSource<<7317917c41ac222c69c05db5c71ea246>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type VerificationType = "Slack" | "%future added value";
export type InstallSlackAppMutationInput = {
  clientMutationId?: string | null;
  installSlackAppCode: string;
  redirect: string;
  useOAuthV2: boolean;
};
export type InstallSlackAppMutation$variables = {
  input: InstallSlackAppMutationInput;
};
export type InstallSlackAppMutation$data = {
  readonly installSlackApp: {
    readonly viewer: {
      readonly verificationCodeResponse: {
        readonly verificationType: VerificationType | null;
        readonly verificationCode: string | null;
        readonly verificationAttempted: boolean | null;
        readonly valid: boolean | null;
        readonly slackTeam: string | null;
        readonly slackUsername: string | null;
      } | null;
    } | null;
    readonly installSlackAppResult: boolean | null;
  } | null;
};
export type InstallSlackAppMutation = {
  variables: InstallSlackAppMutation$variables;
  response: InstallSlackAppMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "VerificationCodeResponse",
  "kind": "LinkedField",
  "name": "verificationCodeResponse",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verificationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verificationCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verificationAttempted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "valid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slackTeam",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slackUsername",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "installSlackAppResult",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InstallSlackAppMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InstallSlackAppMutationPayload",
        "kind": "LinkedField",
        "name": "installSlackApp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InstallSlackAppMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InstallSlackAppMutationPayload",
        "kind": "LinkedField",
        "name": "installSlackApp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6ecd8cc4dba23499d3d6699dc7f5d7a0",
    "id": null,
    "metadata": {},
    "name": "InstallSlackAppMutation",
    "operationKind": "mutation",
    "text": "mutation InstallSlackAppMutation(\n  $input: InstallSlackAppMutationInput!\n) {\n  installSlackApp(input: $input) {\n    viewer {\n      verificationCodeResponse {\n        verificationType\n        verificationCode\n        verificationAttempted\n        valid\n        slackTeam\n        slackUsername\n      }\n      id\n    }\n    installSlackAppResult\n  }\n}\n"
  }
};
})();

(node as any).hash = "9999c3253d5e615e67fcfc9cc4bb7c11";

export default node;
